<!-- <p>communityfundprojectlist works!</p> -->


<!-- <mat-form-field style="width:500px;">
    <mat-label>Search</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Quality Places" #input>
  </mat-form-field> -->

<div class="mat-elevation-z8">
  <p style="color:red;">{{investmenttotalsmessage}}</p>
  <table mat-table [dataSource]="dataSource" matSort>

    

    <ng-container matColumnDef="communityGoal">
      <th mat-header-cell *matHeaderCellDef> Community Goal(s) </th>
      <td mat-cell *matCellDef="let row"> {{row.communityGoal}} </td>
    </ng-container>

    <ng-container matColumnDef="totalAmount">
      <th mat-header-cell *matHeaderCellDef> Amount </th>
      <td mat-cell *matCellDef="let row">
        <ng-container *ngFor="let y of filterYear(row.yearItems)">
          {{y.currencyAmt}}
        </ng-container>

      </td>
    </ng-container>




    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>




  </table>

  <mat-paginator [pageSizeOptions]="[10]" aria-label="Select page of community goals"></mat-paginator>
</div>